import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { AnnouncementBar, FloatingWhatsApp, MobileContactBar } from "./ContactBars";
import { CartDrawer } from "@/components/shop/CartDrawer";
import { useSite } from "@/context/SiteContext";

const SHOP_PATHS = ["/shop", "/checkout", "/order"];

function useScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }
    let tries = 0;
    const timer = setInterval(() => {
      const el = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (el || ++tries > 20) {
        clearInterval(timer);
        el?.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 80);
    return () => clearInterval(timer);
  }, [pathname, hash]);
}

// Keep the footer's last lines clear of the fixed mobile bar and the floating WhatsApp button.
function footerPad(clinic, checkout) {
  if (checkout) return "";
  return clinic ? "pb-20 md:pb-24" : "md:pb-24";
}

export default function PublicLayout() {
  const { pathname } = useLocation();
  const { settings } = useSite();
  const clinic = !SHOP_PATHS.some((p) => pathname.startsWith(p));
  useScrollManager();
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <a href="#main" className="sr-only z-50 rounded-md bg-white px-4 py-2 font-semibold text-brand-blue focus:not-sr-only focus:fixed focus:left-4 focus:top-4">
        Skip to content
      </a>
      <AnnouncementBar />
      <Header />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <Footer className={footerPad(clinic, pathname.startsWith("/checkout"))} />
      {clinic && <MobileContactBar />}
      {!pathname.startsWith("/checkout") && <FloatingWhatsApp />}
      {settings.online_payments_enabled && <CartDrawer />}
    </div>
  );
}
